import { render, staticRenderFns } from "./FilterPrice.vue?vue&type=template&id=74bf697c&scoped=true&"
import script from "./FilterPrice.vue?vue&type=script&lang=js&"
export * from "./FilterPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bf697c",
  null
  
)

export default component.exports